import { render, staticRenderFns } from "./ColumnCard.vue?vue&type=template&id=19630ce4&scoped=true&"
import script from "./ColumnCard.vue?vue&type=script&lang=js&"
export * from "./ColumnCard.vue?vue&type=script&lang=js&"
import style0 from "./ColumnCard.vue?vue&type=style&index=0&id=19630ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19630ce4",
  null
  
)

export default component.exports